import { Flex, Spinner, Text } from "@chakra-ui/react";

export default function LoadingState(props: { label?: string }) {
  return (
    <Flex alignItems="center" gap={2} py={2}>
      <Spinner size="sm" />
      <Text>{props.label ?? "Loading duty code mapping..."}</Text>
    </Flex>
  );
}
